// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18dJw","toggleWrap":"styles_toggleWrap__1Qtgi","content":"styles_content__1KWjM","selectAreaCode":"styles_selectAreaCode__2-KDq"};